import type { AgentDto } from '../../api/types';
import { useDisableAgent, useEnableAgent } from '../../hooks/use-agents';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { useToast } from '../ui/toast';

export function AgentsList({
  agents,
  selectedId,
  onSelect,
}: {
  agents: AgentDto[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}) {
  const enable = useEnableAgent();
  const disable = useDisableAgent();
  const toast = useToast();

  function toggle(agent: AgentDto) {
    const mutation = agent.status === 'active' ? disable : enable;
    mutation.mutate(agent.id, {
      onError: (err) => toast.push(err instanceof Error ? err.message : 'Не удалось изменить статус агента'),
    });
  }

  if (agents.length === 0) {
    return <div className="p-8 text-center text-sm text-muted-fg">Агенты ещё не созданы</div>;
  }

  return (
    <ul className="divide-y divide-border">
      {agents.map((a) => (
        <li
          key={a.id}
          onClick={() => onSelect(a.id)}
          className={`flex cursor-pointer items-center justify-between px-4 py-3 hover:bg-muted/40 ${
            selectedId === a.id ? 'bg-primary/10' : ''
          }`}
        >
          <div>
            <div className="font-medium">{a.name}</div>
            <div className="text-xs text-muted-fg">{a.channel_ids.length} канал(ов)</div>
          </div>
          <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
            <Badge tone={a.status === 'active' ? 'success' : 'neutral'}>{a.status}</Badge>
            <Button size="sm" variant={a.status === 'active' ? 'danger' : 'primary'} onClick={() => toggle(a)}>
              {a.status === 'active' ? 'Выключить' : 'Включить'}
            </Button>
          </div>
        </li>
      ))}
    </ul>
  );
}
